// extracted by mini-css-extract-plugin
var _1 = "wcmNWpT70ertI3EArr7L";
export { _1 as "platoonEmblem" }
